import { Component, EventEmitter, inject, Input, input, Output, ViewChild } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { RouterModule } from '@angular/router'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { map } from 'rxjs'
import { BranchNavItem, SideNavDisplayMode, SideNavGroup, SideNavItem } from '../../navigation/side-nav-item'
import { LogoSize, LogoTheme } from '../../types/logo'
import { FtrLogoComponent } from '../ftr-logo/ftr-logo.component'
import { SideNavShellComponent } from '../side-nav-shell/side-nav-shell.component'
import {
  individualMenuItem,
  USER_AND_ORG_MENU_ITEMS,
  UserAndOrgDropdownComponent,
} from '../user-and-org-dropdown/user-and-org-dropdown.component'

@Component({
  selector: 'ftr-public-side-nav-display',
  templateUrl: './public-side-nav-display.component.html',
  styleUrls: ['./public-side-nav-display.component.css'],
  imports: [SideNavShellComponent, FtrLogoComponent, RouterModule, UserAndOrgDropdownComponent],
})
export class PublicSideNavDisplayComponent {
  @Input() displayMode: SideNavDisplayMode = 'DEFAULT'
  @Input() expanded: boolean = true
  @Input() isLoading: boolean = false
  @Input() isOpened: boolean
  @Output() sideBarToggled = new EventEmitter<void>()
  @Output() expandedToggled = new EventEmitter<void>()

  navGroups = input([] as SideNavGroup[])
  footerItems = input([] as SideNavItem[])
  @ViewChild(SideNavShellComponent) private shell: SideNavShellComponent

  protected readonly logoSize = LogoSize
  protected readonly logoTheme = LogoTheme

  private readonly currentUser = toSignal(
    inject(Store)
      .select(UserState.user)
      .pipe(map(user => user.unwrapOr(undefined))),
  )

  onUserDropdownOpened(): void {
    const user = this.currentUser()
    const menuItems = [...(user ? [individualMenuItem(user)] : []), ...USER_AND_ORG_MENU_ITEMS]
    const children: SideNavItem[] = menuItems.map(item => ({
      type: 'LINK',
      title: item.label,
      path: item.path,
    }))

    this.shell.openBranchNav({ type: 'BRANCH', title: 'Account', children } as BranchNavItem)
  }
}
